import { useRef, useState, useEffect } from "react";

function CameraCapture({ onCapture, onClose }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Start camera when component mounts
    startCamera();

    // Cleanup: stop camera when component unmounts
    return () => {
      stopCamera();
    };
  }, []);

  const startCamera = async () => {
    try {
      // Try high resolution first, fall back to default if not supported
      let mediaStream;
      try {
        mediaStream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: "environment",
            width: { ideal: 1920 }, /* was 3840 */
            height: { ideal: 1080 }, /* was 2160 */
            advanced: [{ zoom: 2.0 }]
          },
          audio: false,
        });
      } catch (err) {
        // Fallback to basic constraints if high resolution fails
        console.warn("High resolution not available, using default", err);
        mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
          audio: false,
        });
      }
      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
    } catch (err) {
      console.error("Error accessing camera:", err);
      setError("Could not access camera. Please check permissions.");
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  };

  const takePicture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (video && canvas) {
      // Set canvas dimensions to match video
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Draw video frame to canvas
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert canvas to data URL
      const imageUrl = canvas.toDataURL("image/png");

      // Stop camera and return image
      stopCamera();
      onCapture(imageUrl);
    }
  };

  const handleClose = () => {
    stopCamera();
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "800px",
          padding: "1rem",
        }}
      >
        {error ? (
          <div style={{ color: "white", textAlign: "center" }}>
            <p>{error}</p>
            <button
              onClick={handleClose}
              style={{
                padding: "0.5rem 1rem",
                fontSize: "1rem",
                cursor: "pointer",
                marginTop: "1rem",
              }}
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <div
              style={{
                position: "relative",
                width: "100%",
                display: "inline-block",
              }}
            >
              <video
                ref={videoRef}
                autoPlay
                playsInline
                style={{
                  width: "100%",
                  maxHeight: "70vh",
                  backgroundColor: "black",
                  borderRadius: "8px",
                  display: "block",
                }}
              />
            </div>
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              <button
                onClick={takePicture}
                style={{
                  padding: "1rem 2rem",
                  fontSize: "1.2rem",
                  cursor: "pointer",
                  backgroundColor: "#00ccffff",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                }}
              >
                📷 Take Picture
              </button>
              <button
                onClick={handleClose}
                style={{
                  padding: "1rem 2rem",
                  fontSize: "1.2rem",
                  cursor: "pointer",
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                }}
              >
                Abbrechen
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CameraCapture;
